import React, { useState, useCallback, useEffect, useMemo, useRef } from "react";
import styled, { withTheme } from "styled-components";
import { use100vh } from "react-div-100vh";
import Modal from "common/Modal";
import ExportCSV from "common/ExportCSV";
import Geocode from "react-geocode";
import { useForm, Controller } from "react-hook-form";
import Select, { components, createFilter } from "react-select";
import companyDump from "utils/companyDump.json";
import InputWithLabel from "common/InputWithLabel";
import {
  Search,
  PictureAsPdf,
  Bookmark,
  Close,
  BookmarkBorder,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";

import { usePrepareData } from "utils/usePrepareData";
import setCoordinates from "utils/setGoogleMapsCoordinates";

import useSessionStorage from "utils/useSessionStorage";
import { NotificationManager } from "react-notifications";

import { doCompanySearch, setCompanyFavouriteGRSDB, deleteCompanyFavouritesGRSDB } from "utils/api";
import debounce from "lodash/debounce";
import Button from "common/Button";

import InfiniteList from "common/InfiniteList";
import ExportCompanies from "utils/exportCompanies";
import renderCompany from "./CompanySearchComponents/renderCompany";
import BatchEditComp from "./CompanySearchComponents/BatchEdit";
import SaveSearchModal from "./CompanySearchComponents/SaveSearchModal";
import { formInitialValues } from "./CompanySearchComponents/constants";
import { getFilterData, checkFiltersSimilarity } from "./CompanySearchComponents/utils";
import { useAsyncLoader } from "utils/useAsyncLoader";
import { getFilters, deleteFilter, updateFilter } from "utils/api";

import { customStylesSelectEventFn, customStylesSelectFn } from "./CompanySearchStyles";
Geocode.setApiKey("AIzaSyDvXLFUSfLOZVCuK3_E3FwBn3lieP8Gt4U");
const EventContainer = styled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  width: ${({ customWidth }) => (customWidth ? customWidth : "100%")};
  margin-bottom: 0rem;
  margin-left: 20px;
`;

const ContainerResult = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.black75};
  font-weight: bold;
  margin-bottom: 6px;
  width: 100%;
  display: flex;
`;

const StyledInputNameContainer = styled.div`
  margin-bottom: ${({ select }) => select && "1.8rem"};
`;
const StyledSelectHolder = styled.div`
  margin-bottom: 8px;
`;
const SelectLabel = styled.span`
  padding-bottom: 0.5%;
  font-size: 13px;
  color: ${({ theme }) => theme.black75};
  font-weight: bold;
  line-height: 2;
`;
const NumbersInputContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const StyledSearch = styled(Search)`
  color: ${({ theme }) => theme.black100};
  font-size: 1.2rem !important;
`;

const StyledForm = styled.form`
  padding: 0px 18px 10px 18px;
`;
const NoResultMsg = styled.div`
  font-size: 14px;
`;
const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;
const Opt = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: default;
  font-size: inherit;
  padding: 8px 12px;
  width: 100%;
  user-select: none;
  box-sizing: border-box;
  :hover {
    background: #f1f1f1;
  }
`;

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <StyledSearch />
    </components.DropdownIndicator>
  );
};

function FirmenCount({ count }) {
  const company = count === 1 ? "Firma" : "Firmen";
  return (
    <div style={{ fontSize: 14, padding: "4px 0px", width: 250 }}>
      <b>{count}</b> {company} gefunden
    </div>
  );
}

function ToggleFilter({ toggleFilter, setToggleFilter }) {
  return (
    <button
      style={{
        border: "none",
        background: "none",
        padding: 0,
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        fontSize: "14px",
        margin: "0 0 5px",
        fontWeight: "bold",
        color: "#EC7D28",
      }}
      type="button"
      onClick={() => setToggleFilter(!toggleFilter)}
    >
      {toggleFilter ? "Filter ausblenden" : "Filter einblenden"}
      {toggleFilter ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />}
    </button>
  );
}

function getFilterName(filter) {
  if (filter.filter_name.replace(/ /g, "")) {
    return filter.filter_name;
  }
  const { filter_name, ...rest } = filter;
  return Object.keys(rest).reduce((prev, curr) => {
    if (["branchSelect", "eventSelect"].includes(curr)) {
      return `${prev} ${rest[curr].map(i => i.label).join(" , ")}`;
    }
    if (rest[curr]) {
      console.log(rest[curr]);
      return `${prev} ${rest[curr]}`;
    }
    return prev;
  }, "");
}

function Filters({
  branchSelectValues,
  eventSelectValues,
  setSelectedFilter,
  areFiltersSame,
  setIsOpenSaveSearch,
  customStylesSelectEvent,
  resetFormValues,
  Menu,
  selectedFilter,
  theme,
  reload,
  getValues,
  trigger,
}) {
  const { data: filters, error, isLoading } = useAsyncLoader(getFilters, trigger);

  const savedFilterOptions = useMemo(
    () => (filters || []).map(f => ({ label: getFilterName(f.filters), value: f.id })),
    [filters]
  );
  const selectedOption = useMemo(
    () =>
      (filters || []).length &&
      selectedFilter && { label: getFilterName(selectedFilter.filters), value: selectedFilter.id },
    [filters, selectedFilter]
  );

  const onSelectFilter = useCallback(
    data => {
      setSelectedFilter(data);
    },
    [setSelectedFilter]
  );

  const Option = useCallback(
    ({ data, innerProps }) => (
      <Opt {...innerProps}>
        <span>{data.label}</span>
        <div
          style={{ display: "flex" }}
          onClick={async e => {
            try {
              await deleteFilter(data.value);
              resetFormValues();
              reload();
              e.stopPropagation();
            } catch (e) {
              NotificationManager.error(e.toString());
            }
          }}
        >
          <Close style={{ color: theme.redColor, cursor: "pointer", zIndex: 1000 }} />
        </div>
      </Opt>
    ),
    [reload, resetFormValues, theme.redColor]
  );

  const updateFilterfn = useCallback(
    async id => {
      const values = getValues();
      try {
        const data = await updateFilter(id, {
          ...values,
          branchSelect: branchSelectValues,
          eventSelect: eventSelectValues,
          filter_name: selectedFilter?.filters?.filter_name,
        });
        reload();
        setSelectedFilter(data);
      } catch (e) {
        NotificationManager.error(e.toString());
      }
    },
    [getValues, branchSelectValues, eventSelectValues, selectedFilter, reload, setSelectedFilter]
  );
  return (
    <StyledSelectHolder>
      <Wrapper>
        <div style={{ width: "100%" }}>
          <SelectLabel>Gespeicherte Suche verwenden</SelectLabel>
          <Select
            // improve typing massively making stripDiacritics not to call
            filterOption={createFilter({ ignoreAccents: false })}
            styles={customStylesSelectEvent}
            onChange={(opt, e1, e2) => onSelectFilter(filters.find(f => f.id === opt.value))}
            components={{
              IndicatorSeparator: () => null,
              Menu,
              Option,
            }}
            placeholder=""
            options={savedFilterOptions || []}
            value={selectedOption}
          />
        </div>
        <div style={{ padding: "2px", marginLeft: "6px" }}>
          {selectedFilter && areFiltersSame ? (
            <Bookmark
              onClick={() => setIsOpenSaveSearch(true)}
              style={{ color: theme.primaryColor }}
            />
          ) : (
            <BookmarkBorder onClick={() => setIsOpenSaveSearch(true)} />
          )}
        </div>
        <div>
          {selectedFilter && !areFiltersSame ? (
            <Button
              type="button"
              onClick={() => updateFilterfn(selectedFilter.id)}
              text="Änderung speichern"
              color={theme.primaryColor}
              background="#fff"
              padding="0"
              textSize="12px"
            />
          ) : null}
        </div>
      </Wrapper>
    </StyledSelectHolder>
  );
}

function CompanySearch({
  toggleModal,
  setToggleModal,
  setSelectedCompany,
  setSelectedRoute,
  selectedRoute,
  theme,
}) {
  const listRef = useRef();
  const [trigger, reloadFilter] = useState(new Date());

  const [isOpenSaveSearch, setIsOpenSaveSearch] = useState(false);
  const [selectedFilter, setSelectedFilter] = useSessionStorage("selectedFilter", "");
  // const [areFiltersSame, setAreFilterSame] = useState(false);

  const [sessionFormValues, setSessionFormValues] = useSessionStorage("companySearchValues", "");

  const [sessionBranchValues, setSessionBranchValues] = useSessionStorage(
    "companyBranchValues",
    ""
  );
  const [sessionEventValues, setSessionEventValues] = useSessionStorage("companyEventValues", "");

  const { channels } = usePrepareData();

  const initialFormValues = useMemo(() => {
    const parsedFormValues = sessionFormValues && JSON.parse(sessionFormValues);
    const parsedBranchValues = sessionBranchValues && JSON.parse(sessionBranchValues);
    const parsedEventValues = sessionEventValues && JSON.parse(sessionEventValues);

    return {
      ...parsedFormValues,
      branchSelect: parsedBranchValues,
      eventSelect: parsedEventValues,
    };
  }, [sessionBranchValues, sessionEventValues, sessionFormValues]);

  const [searchResults, setSearchResults] = useState([]);
  const [count, setCount] = useState(0);
  const [toggleFilter, setToggleFilter] = useState(true);
  const [startIndex, setStartIndex] = useState(0);
  const [isSearching, setIsSearching] = useState(false);
  const [currentSearchQuery] = useState(null);
  const firstRender = useRef(true);

  const height100 = use100vh();

  const decideHeight = useMemo(() => {
    if (toggleFilter) {
      return selectedRoute?.length > 0 ? `${height100 - 615}px` : `${height100 - 545}px`;
    } else {
      return selectedRoute?.length > 0 ? `${height100 - 215}px` : `${height100 - 155}px`;
    }
  }, [height100, selectedRoute, toggleFilter]);

  const [showMore, setShowMore] = useState(false);

  const [isLoading, setIsLoading] = useState({ word: false, pdf: false });
  const [branchSelectValues, setBranchSelectValues] = useState(
    initialFormValues?.branchSelect || []
  );
  const [eventSelectValues, setEventSelectValues] = useState(initialFormValues?.eventSelect || []);

  const formp = useForm({
    defaultValues: initialFormValues,
  });
  const { control, register, errors, getValues, reset } = formp;

  const channelsOpt = useMemo(() => {
    return channels.map(c => ({ label: c.name, value: c.id }));
  }, [channels]);

  const scrollTo = useCallback(
    index => {
      if (showMore) {
        // eslint-disable-next-line no-unused-expressions
        listRef?.current?._listRef?.scrollTo(index * 100);
        // index * 100 where 100 is the itemHeight
      } else {
        // eslint-disable-next-line no-unused-expressions
        listRef?.current?._listRef?.scrollTo(index * 150);
        // index * 150 where 150 is the itemHeight
      }
    },
    [showMore]
  );

  const customStylesSelectEvent = useMemo(() => customStylesSelectEventFn(theme), [theme]);

  const customStylesSelect = useMemo(() => customStylesSelectFn(theme), [theme]);

  const getCompanyResults = useCallback(
    async (data, startIndex, reset) => {
      if (currentSearchQuery) {
        currentSearchQuery.abort();
      }
      const res = await doCompanySearch({
        data,
        ensureURLSingleRequest: true,
      });
      setCount(res?.count);
      setSearchResults(sResults => {
        const newItems = reset ? [] : sResults;
        let index = startIndex;
        res.results.forEach(item => {
          item.company_events = item?.company_events.filter(
            (value, index, self) => index === self.findIndex(t => t.event_type === value.event_type)
          );
          newItems[index] = item;
          index += 1;
        });
        return newItems;
      });

      setIsSearching(true);
    },
    [currentSearchQuery]
  );

  useEffect(() => {
    const formValues = getValues();
    if (firstRender.current) {
      const filter = getFilterData(initialFormValues, 0);
      firstRender.current = false;
      getCompanyResults(filter, 0);
    } else {
      const data = {
        ...formValues,
        eventSelect: eventSelectValues,
        branchSelect: branchSelectValues,
      };

      const filter = getFilterData(data, startIndex);
      getCompanyResults(filter, startIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startIndex]);

  const onFilterSelect = useCallback(
    data => {
      setSelectedFilter(data);
      const values = data.filters;
      reset(values);
      setSessionFormValues(JSON.stringify(values));
      const params = {
        ...values,
        eventSelect: values.eventSelect,
        branchSelect: values.branchSelect,
      };

      const filter = getFilterData(params, 0);
      getCompanyResults(filter, 0, true);
      setBranchSelectValues(values.branchSelect);
      setEventSelectValues(values.eventSelect);
      setSessionBranchValues(JSON.stringify(values.branchSelect));
      setSessionEventValues(JSON.stringify(values.eventSelect));
    },
    [
      getCompanyResults,
      reset,
      setSelectedFilter,
      setSessionBranchValues,
      setSessionEventValues,
      setSessionFormValues,
    ]
  );

  const onFormChange = useCallback(
    debounce(props => {
      const formValues = getValues();
      const data = {
        ...formValues,
        branchSelect: branchSelectValues,
        eventSelect: eventSelectValues,
      };
      const filter = getFilterData(data, 0);
      getCompanyResults(filter, 0, true);
      setSessionFormValues(JSON.stringify(formValues));
    }, 500),
    [branchSelectValues, eventSelectValues]
  );
  const values = getValues();

  const areFiltersSame = useMemo(
    () =>
      selectedFilter &&
      checkFiltersSimilarity(
        { ...values, branchSelect: branchSelectValues, eventSelect: eventSelectValues },
        selectedFilter?.filters
      ),
    [branchSelectValues, eventSelectValues, selectedFilter, values]
  );

  async function handleCompanyFavorite(id) {
    let tempArr = [...searchResults];
    const company = searchResults.find(comp => comp && comp.id === id);
    const isFavorit = company.favorite;
    company.favorite = !company.favorite;
    setSearchResults(tempArr);
    try {
      if (isFavorit) {
        await deleteCompanyFavouritesGRSDB(company.bisnode_id);
      } else {
        const updatedCompany = await setCoordinates(company);
        await setCompanyFavouriteGRSDB(updatedCompany);
      }
    } catch (e) {
      NotificationManager.error("Operation fehlgeschlagen");
      company.favorite = isFavorit;
      setSearchResults([...tempArr]);
    }
  }

  const handleMultiChangeBranch = v => {
    const formValues = getValues();
    setBranchSelectValues(v[0]);

    const data = {
      ...formValues,
      branchSelect: v[0],
      eventSelect: eventSelectValues,
    };
    const filter = getFilterData(data, 0);
    getCompanyResults(filter, 0, true);
    setSessionBranchValues(JSON.stringify(v[0]));
  };

  const handleChangeEvent = useCallback(
    e => {
      const formValues = getValues();
      setEventSelectValues(e[0]);
      const data = {
        ...formValues,
        eventSelect: e[0],
        branchSelect: branchSelectValues,
      };
      const filter = getFilterData(data, 0);
      getCompanyResults(filter, 0, true);
      setSessionEventValues(JSON.stringify(e[0]));
    },
    [branchSelectValues, getCompanyResults, getValues, setSessionEventValues]
  );

  const onRequestClose = useCallback(() => {
    setTimeout(() => {
      setToggleModal(0);
    }, 50);
  }, [setToggleModal]);

  const Menu = props => {
    const optionSelectedLength = props.getValue().length || 0;
    return (
      <components.Menu {...props}>
        {optionSelectedLength < 3 ? props.children : null}
      </components.Menu>
    );
  };
  const MenuEvents = props => {
    const optionSelectedLength = props.getValue().length || 0;
    return (
      <components.Menu {...props}>
        {optionSelectedLength < 1 ? props.children : null}
      </components.Menu>
    );
  };

  function exportableCompanies() {
    if (!searchResults) {
      return [];
    }
    return searchResults.slice(0, parseInt(process.env.REACT_APP_SEARCH_LIMIT));
  }

  const csvDataBuilder = useCallback(() => {
    const res = [];
    if (!searchResults) {
      return res;
    }
    const exportCompanies = exportableCompanies();
    if (exportCompanies && exportCompanies.length > 0) {
      exportCompanies.forEach(company => {
        const rowdata = {
          COMPANY_NAME: company?.co_name,
          STREET: company?.co_street,
          ZIP: company?.co_zip,
          CITY: company?.co_city,
          TELEFON: company?.co_phone,
          EMAIL: company?.co_email,
          URL: company?.co_url,
          EMPLOYEES: company?.employees,
          BRANCHES: company?.company_wz2008
            .map(b => `${b.wz2008_text} (${b.wz2008_code})`)
            .join(", "),
          EVENTS: company?.company_events.map(b => `${b.event_type_description}`).join(", "),
        };
        res.push(rowdata);
      });
    }

    return res;
  }, [searchResults]);

  const resetFormValues = useCallback(() => {
    setSessionFormValues("");
    setSessionBranchValues("");
    setSessionEventValues("");
    setSelectedFilter(null);
    console.log(formInitialValues, "formInitialValues");
    reset(formInitialValues);
    const filter = getFilterData(formInitialValues, 0);
    getCompanyResults(filter, 0, true);
  }, [
    getCompanyResults,
    reset,
    setSelectedFilter,
    setSessionBranchValues,
    setSessionEventValues,
    setSessionFormValues,
  ]);

  if (isOpenSaveSearch) {
    return (
      <SaveSearchModal
        reload={() => reloadFilter(new Date())}
        isOpen={isOpenSaveSearch}
        setIsOpen={setIsOpenSaveSearch}
        setSelectedFilter={onFilterSelect}
        searchValues={{
          ...getValues(),
          branchSelect: branchSelectValues,
          eventSelect: eventSelectValues,
        }}
      />
    );
  }

  const showExportButtons = localStorage.getItem("export_allowed") === "true";
  return (
    <Modal
      isOpen={toggleModal === 4}
      onRequestClose={onRequestClose}
      modalTitle="Firmensuche"
      Icon={Search}
    >
      <StyledForm onChange={onFormChange}>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <ToggleFilter setToggleFilter={setToggleFilter} toggleFilter={toggleFilter} />{" "}
          <button
            type="button"
            onClick={resetFormValues}
            style={{
              border: "none",
              background: "none",
              cursor: "pointer",
              padding: 0,
              fontSize: "14px",
              margin: "0 0 5px",
              fontWeight: "bold",
              color: theme.primaryColor,
            }}
          >
            Suche zurücksetzen
          </button>
        </div>
        <div style={{ display: !toggleFilter ? "none" : "inherit" }}>
          <Filters
            eventSelectValues={eventSelectValues}
            branchSelectValues={branchSelectValues}
            setSelectedFilter={onFilterSelect}
            getValues={getValues}
            trigger={trigger}
            register={register}
            areFiltersSame={areFiltersSame}
            setIsOpenSaveSearch={setIsOpenSaveSearch}
            customStylesSelectEvent={customStylesSelectEvent}
            control={control}
            Menu={Menu}
            selectedFilter={selectedFilter}
            theme={theme}
            reload={() => reloadFilter(new Date())}
            resetFormValues={resetFormValues}
          />
          <StyledInputNameContainer style={{ display: "flex" }}>
            <InputWithLabel
              reg={register}
              companySearch
              name="q"
              type="text"
              label="Firmenname"
              placeholder="Firmenname"
              errors={errors}
            />
            <InputWithLabel
              isNotFirst
              reg={register}
              companySearch
              name="city"
              type="text"
              label="Stadt"
              placeholder="Stadt"
              errors={errors}
            />
            <EventContainer>
              <SelectLabel>Ereignisse</SelectLabel>
              <Controller
                // improve typing massively making stripDiacritics not to call
                filterOption={createFilter({ ignoreAccents: false })}
                reg={register}
                styles={customStylesSelectEvent}
                as={Select}
                name="eventSelect"
                control={control}
                isClearable={false}
                onChange={handleChangeEvent}
                components={{
                  DropdownIndicator,
                  IndicatorSeparator: () => null,
                  Menu: MenuEvents,
                }}
                placeholder="Ereignisse auswählen..."
                options={channelsOpt}
                isSearchable={eventSelectValues?.length === 1 ? false : true}
                isMulti
              />
              <InputWithLabel
                name="filter_events_only"
                isNotFirst
                reg={register}
                companySearch
                control={control}
                type="checkbox"
                label="Beliebiges Ereignis"
                errors={errors}
                inputStyle={{ height: "auto", width: "auto" }}
                style={{
                  flexFlow: "row nowrap",
                  alignItems: "center",
                  flexDirection: "row-reverse",
                  width: "auto",
                  marginLeft: "0",
                  justifyContent: "flex-end",
                }}
              />
            </EventContainer>
          </StyledInputNameContainer>
          <StyledSelectHolder>
            <SelectLabel>Branche (max. 3)</SelectLabel>
            <Controller
              // improve typing massively making stripDiacritics not to call
              filterOption={createFilter({ ignoreAccents: false })}
              reg={register}
              styles={customStylesSelect}
              as={Select}
              name="branchSelect"
              control={control}
              onChange={handleMultiChangeBranch}
              components={{
                DropdownIndicator,
                IndicatorSeparator: () => null,
                Menu,
              }}
              placeholder="Branche auswählen..."
              options={companyDump}
              isSearchable={branchSelectValues?.length === 3 ? false : true}
              isMulti
            />
          </StyledSelectHolder>

          <StyledInputNameContainer>
            <NumbersInputContainer>
              <InputWithLabel
                reg={register}
                companySearch
                name="plzStart"
                type="number"
                label="PLZ von"
                placeholder="PLZ von"
                errors={errors}
              />
              <InputWithLabel
                reg={register}
                companySearch
                isNotFirst
                name="plzEnd"
                type="number"
                label="PLZ bis"
                placeholder="PLZ bis"
                errors={errors}
              />
              <InputWithLabel
                reg={register}
                isNotFirst
                companySearch
                name="startNumber"
                type="number"
                label="Mitarbeiter Anzahl von"
                placeholder="Zahl eingeben..."
                errors={errors}
              />
              <InputWithLabel
                reg={register}
                isNotFirst
                companySearch
                name="endNumber"
                type="number"
                label="Mitarbeiter Anzahl bis"
                placeholder="Zahl eingeben..."
                errors={errors}
              />
            </NumbersInputContainer>
          </StyledInputNameContainer>
        </div>
        <StyledInputNameContainer>
          {searchResults.length > 0 && (
            <ContainerResult>
              {showExportButtons ? (
                <>
                  <FirmenCount count={count} />
                  <div
                    style={{
                      display: "flex",
                      flexAlign: "right",
                      width: "100%",
                      justifyContent: "right",
                    }}
                  >
                    <div
                      title="Excel"
                      alt="Excel"
                      style={{ cursor: "pointer", marginRight: 5 }}
                      onClick={() => csvDataBuilder()}
                    >
                      <ExportCSV
                        fileName="company_search"
                        style={{
                          marginBottom: "5px",
                          textDecoration: "none",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                        csvDataBuilder={csvDataBuilder}
                        buttonLabel="Excel"
                      />
                    </div>
                    <div style={{ marginRight: 5 }}>
                      <div
                        title="Word"
                        alt="Word"
                        style={{ cursor: "pointer", width: "34px" }}
                        onClick={async () => {
                          setIsLoading({ ...isLoading, word: true });
                          await ExportCompanies.asWord(exportableCompanies());
                          setIsLoading({ ...isLoading, word: false });
                        }}
                      >
                        {isLoading?.word ? (
                          <CircularProgress disableShrink color="inherit" size={20} />
                        ) : (
                          "Word"
                        )}
                      </div>
                    </div>
                    <div
                      title="PDF"
                      alt="PDF"
                      style={{ cursor: "pointer", width: "25px" }}
                      onClick={async () => {
                        setIsLoading({ ...isLoading, pdf: true });
                        await ExportCompanies.asPdf(exportableCompanies());
                        setIsLoading({ ...isLoading, pdf: false });
                      }}
                    >
                      {isLoading?.pdf ? (
                        <CircularProgress disableShrink color="inherit" size={20} />
                      ) : (
                        <PictureAsPdf />
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <FirmenCount count={count} />
              )}
            </ContainerResult>
          )}
          {searchResults.length === 0 && isSearching && (
            <NoResultMsg>Keine passende Ergebnisse gefunden</NoResultMsg>
          )}
          <InfiniteList
            height={decideHeight}
            isItemLoaded={index => searchResults[index]}
            loadMoreItems={sIndex => setStartIndex(sIndex)}
            itemCount={count}
            listRef={listRef}
            itemSize={showMore ? 150 : 125}
            renderItem={index =>
              renderCompany(
                searchResults[index],
                setSelectedCompany,
                setToggleModal,
                handleCompanyFavorite,
                setSelectedRoute,
                selectedRoute,
                channels,
                theme,
                showMore,
                setShowMore,
                scrollTo,
                index
              )
            }
          />
        </StyledInputNameContainer>
      </StyledForm>
      {selectedRoute?.length > 0 ? (
        <BatchEditComp setSelectedRoute={setSelectedRoute} setToggleModal={setToggleModal} />
      ) : null}
    </Modal>
  );
}

export default withTheme(CompanySearch);
